import React, { useState, useEffect } from 'react'; 
import LoginView from './LoginView';
import RegistroAdmin from './RegistroAdminView';
// ❌ Quitamos el Navbar genérico de aquí, porque este panel es PRE-LOGIN
import './IntroAdminPanel.css';

function IntroAdminPanel({ defaultVista = 'inicio' }) {
  const [vista, setVista] = useState(defaultVista);

  useEffect(() => {
    setVista(defaultVista);
  }, [defaultVista]); 

  const renderVista = () => {
    switch (vista) {
      case 'login':
        return (
          <>
            <LoginView />
            {/* <p style={{ color: '#fff', marginTop: '15px', textAlign: 'center' }}>
              ¿No tienes cuenta? <span style={{ color: '#ff0000', cursor: 'pointer' }} onClick={() => setVista('registro')}>Regístrate</span>
            </p> */}
          </>
        );
      case 'registro':
        return (
          <>
            <RegistroAdmin />
            <p style={{ color: '#fff', marginTop: '15px', textAlign: 'center' }}>
              ¿Ya tienes cuenta? <span style={{ color: '#ff0000', cursor: 'pointer' }} onClick={() => setVista('login')}>Ingresa</span>
            </p>
          </>
        );
      default:
        return (
          <div style={{
            backgroundColor: '#111',
            padding: '40px',
            borderRadius: '8px',
            boxShadow: '0 0 10px rgba(255, 0, 0, 0.5)',
            width: '100%',
            maxWidth: '400px',
            margin: '40px auto',
            textAlign: 'center'
          }}>
            <h1 style={{ color: '#ff0000', marginBottom: '30px' }}>Bienvenido a Clavelina Admin</h1>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              <button className="intro-button" onClick={() => setVista('login')}>Ingresar</button>
              <button className="intro-button" onClick={() => setVista('registro')}>Registrarse</button>
            </div>
          </div>
        );
    }
  };

  return (
    <div className="intro-fondo">
      {/* Aquí ya no ponemos el <Navbar />. 
         El AdminNavbar aparecerá AUTOMÁTICAMENTE cuando 
         el usuario loguee y sea redirigido a /admin 
         gracias a la estructura que pusimos en App.js
      */}
      <div className="intro-content">
        {renderVista()}
      </div>
    </div>
  );
}

export default IntroAdminPanel;